var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContextempty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 301.04 214.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-13 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke: #003c71;\r\n        stroke-dasharray: 5;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        opacity: 0;\r\n      }\r\n\r\n      .cls-3, .cls-5 {\r\n        fill: #1ee5a0;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-5 {\r\n        font-size: 31px;\r\n        font-family: MaterialIcons-Regular, Material Icons;\r\n      }\r\n\r\n      .cls-5, .cls-6, .cls-8, .cls-9 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-10, .cls-11, .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        fill: #003c71;\r\n      }\r\n\r\n      .cls-6, .cls-7, .cls-9 {\r\n        font-size: 15px;\r\n      }\r\n\r\n      .cls-6, .cls-7 {\r\n        font-family: Calibri-Bold, Calibri;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-7 {\r\n        letter-spacing: 0.05em;\r\n      }\r\n\r\n      .cls-8 {\r\n        font-size: 16px;\r\n      }\r\n\r\n      .cls-10, .cls-8, .cls-9 {\r\n        font-family: Calibri;\r\n      }\r\n\r\n      .cls-10 {\r\n        font-size: 20px;\r\n      }\r\n\r\n      .cls-12 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "context_empty",
    "data-name": "context empty",
    transform: "translate(-9.5 -435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "context",
    transform: "translate(-20 -89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg",
    className: "cls-1",
    transform: "translate(30.5 544)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    width: 299.04,
    height: 193.68,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: -0.5,
    y: -0.5,
    width: 300.04,
    height: 194.68,
    rx: 10.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "check_box",
    "data-name": "check box",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    className: "cls-3",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(155.73 524)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2086",
    "data-name": "Group 2086",
    transform: "translate(160.645 529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    className: "cls-4",
    d: "M1.583-17.5a2.306,2.306,0,0,1,1.679.728,2.306,2.306,0,0,1,.728,1.679V1.583a2.306,2.306,0,0,1-.728,1.679,2.306,2.306,0,0,1-1.679.728H-15.094a2.306,2.306,0,0,1-1.679-.728A2.306,2.306,0,0,1-17.5,1.583V-15.094a2.306,2.306,0,0,1,.728-1.679,2.306,2.306,0,0,1,1.679-.728Z",
    transform: "translate(21.755 21.755)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\uE834",
    className: "cls-5",
    transform: "translate(31 31)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31,
    y: 0
  }, "\uE834")))), /*#__PURE__*/React.createElement("text", {
    id: "_Placeholder_Label",
    "data-name": "\\u21B3 Placeholder Label",
    className: "cls-6",
    transform: "translate(320 589)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -168.333,
    y: 0
  }, "Sevilla Knutsen / 93333802")), /*#__PURE__*/React.createElement("text", {
    id: "_Placeholder_Label-2",
    "data-name": "\\u21B3 Placeholder Label",
    className: "cls-7",
    transform: "translate(320 619)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -98.253,
    y: 0
  }, "181781 / 2018")), /*#__PURE__*/React.createElement("text", {
    id: "_Placeholder_Label-3",
    "data-name": "\\u21B3 Placeholder Label",
    className: "cls-6",
    transform: "translate(320 649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -68.778,
    y: 0
  }, "21.03.2018")), /*#__PURE__*/React.createElement("text", {
    id: "_Placeholder_Label-4",
    "data-name": "\\u21B3 Placeholder Label",
    className: "cls-6",
    transform: "translate(320 679)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.13,
    y: 0
  }, "H&amp;M")), /*#__PURE__*/React.createElement("text", {
    id: "_Placeholder_Label-5",
    "data-name": "\\u21B3 Placeholder Label",
    className: "cls-7",
    transform: "translate(320 709)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -173.663,
    y: 0
  }, "Knutsen OAS Shipping AS")), /*#__PURE__*/React.createElement("text", {
    id: "_Placeholder_Label-6",
    "data-name": "\\u21B3 Placeholder Label",
    className: "cls-8",
    transform: "translate(40 589)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Object name")), /*#__PURE__*/React.createElement("text", {
    id: "_Placeholder_Label-7",
    "data-name": "\\u21B3 Placeholder Label",
    className: "cls-9",
    transform: "translate(40 619)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Claim number")), /*#__PURE__*/React.createElement("text", {
    id: "_Placeholder_Label-8",
    "data-name": "\\u21B3 Placeholder Label",
    className: "cls-9",
    transform: "translate(40 709)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Assured ")), /*#__PURE__*/React.createElement("text", {
    id: "_Placeholder_Label-9",
    "data-name": "\\u21B3 Placeholder Label",
    className: "cls-9",
    transform: "translate(40 649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Claim date")), /*#__PURE__*/React.createElement("text", {
    id: "_Placeholder_Label-10",
    "data-name": "\\u21B3 Placeholder Label",
    className: "cls-9",
    transform: "translate(40 679)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Interest"))), /*#__PURE__*/React.createElement("text", {
    id: "Finding_context",
    "data-name": "Finding context",
    className: "cls-10",
    transform: "translate(160 577)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -62.271,
    y: 0
  }, "Finding context")), /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(148 523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8405",
    "data-name": "Path 8405",
    className: "cls-11",
    d: "M10,19a9,9,0,1,1,9-9A9,9,0,0,1,10,19ZM10,3a7,7,0,1,0,7,7,7,7,0,0,0-7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8406",
    "data-name": "Path 8406",
    className: "cls-11",
    d: "M7,10H5a5.006,5.006,0,0,1,5-5V7a3,3,0,0,0-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8407",
    "data-name": "Path 8407",
    className: "cls-11",
    d: "M22.707,21.293l-4.256-4.256a10.982,10.982,0,0,1-1.414,1.414l4.256,4.256a1,1,0,1,0,1.414-1.414Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextempty);
export default __webpack_public_path__ + "static/media/context empty.155660a2f0ffa65e85e0e18941c8d65c.svg";
export { ForwardRef as ReactComponent };